import ConnectyCube from "connectycube"

const CONFIG = {
    appId: process.env.CONNECTYCUBE_APP_ID,
    authKey: process.env.CONNECTYCUBE_AUTH_KEY,
    chat: {
        streamManagement: {
            enable: true
        }
    }
}

const CREDENTIALS = {
    appId: CONFIG.appId,
    authKey: CONFIG.authKey
}

const APP_CONFIG = {
    debug: { mode: 1 },
    endpoints: {
        api: "api.connectycube.com",
        chat: "chat.connectycube.com:5291"
    },
    webrtc: {
        answerTimeInterval: 30,
        dialingTimeInterval: 5,
        disconnectTimeInterval: 300,
        statsReportTimeInterval: 5
    }
}

// Initialize ConnectyCube
ConnectyCube.init(CREDENTIALS, {
    debug: {
        mode: 0,
    },
});

export default ConnectyCube